import { CommonModule } from '@angular/common';
import { DefaultLayoutComponent } from './components/pages/default-layout/default-layout.component';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginPageComponent } from './components/pages/login-page/login-page.component';
import { AuthService } from './components/services/auth/auth.service';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastMessage } from './models/database';
import { ToastService } from './components/services/toast/toast.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, DefaultLayoutComponent, NgbToastModule, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  title = 'STDG';

  constructor(
    private authservice: AuthService,
    public toastService: ToastService
  ){}

  ngOnInit(): void {
    this.authservice.handleRedirectCallback();
  }
}
